import React, { useState, useEffect,useRef } from "react";
import VideoRecorder from "react-video-recorder";
import logo from "../assets/images/logo.png";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import Axios from "axios";
import { GetJobRoles, HRinitialScreening, PostAttemptedQuestions, TestSaveCandidateRecordedVideo,GetInterviewDetailWithOutQuns, GenerateContent, AddCodingIntQuns } from "../apiconstants/constants";
import LoadingSpinner from "../helpers/loadingspinner";
import parse from 'html-react-parser';
import DOMPurify from "dompurify";
import { Editor } from "@monaco-editor/react";
import NoMobileAccess from "../nomobileaccess";
import ailogo from "../assets/images/ai.jpg"
import alertimg from  "../assets/images/aitestalert.png";
const CODE_SNIPPETS = {
    javascript: `console.log("Hello, World!");`,
    typescript: `const greet = (name: string) => console.log("Hello, " + name);\ngreet("World");`,
    python: `print("Hello, World!")`,
    java: `public class Main {\n    public static void main(String[] args) {\n        System.out.println("Hello, World!");\n    }\n}`,
    csharp: `using System;\nclass Program {\n    static void Main() {\n        Console.WriteLine("Hello, World!");\n    }\n}`,
    php: `<?php\necho "Hello, World!";\n?>`,
    sql: `SELECT 'Hello, World!';`,
    c: `#include <stdio.h>\nint main() {\n    printf("Hello, World!\\n");\n    return 0;\n}`,
    cpp: `#include <iostream>\nint main() {\n    std::cout << "Hello, World!\\n";\n    return 0;\n}`,
    swift: `print("Hello, World!")`,
  };
  
  export const LANGUAGE_VERSIONS = {
    javascript: "18.15.0",
    typescript: "5.0.3",
    python: "3.10.0",
    java: "15.0.2",
    csharp: "6.12.0",
    php: "8.2.3",
    sql: "2023",
    c: "10.2.0",
    cpp: "10.2.0",
    swift: "5.3.3",
  };
 
  const API = Axios.create({
    baseURL: "https://emkc.org/api/v2/piston",
  });
  
  export const executeCode = async (language, sourceCode) => {
    try {
      const response = await API.post("/execute", {
        language: language,
        version: LANGUAGE_VERSIONS[language],
        files: [{ content: sourceCode }],
      });
  
      return response.data?.run || { output: "No output received", stderr: true };
    } catch (error) {
      return { output: `Error: ${error.message}`, stderr: true };
    }
  };
  
  const Output = ({ editorRef, language,resetTrigger  }) => {
    const [output, setOutput] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (resetTrigger) {
      setOutput(null);
      setIsError(false);
    }
  }, [resetTrigger]);

    const runCode = async () => {
      const sourceCode = editorRef.current.getValue();
      if (!sourceCode) return;
  
      try {
        setIsLoading(true);
        const result = await executeCode(language, sourceCode);
        setOutput(result.output ? result.output.split("\n") : ["No output"]);
        setIsError(!!result.stderr);
      } catch (error) {
        setOutput(["Execution failed. Check console logs."]);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
  
    return (
      <div style={{  padding: "10px"}}>
          <h6 style={{color:"#00a7ac"}}>Output</h6>
        <button    className="btn btn-primary"
                        style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: 15,  padding: "5px 10px", marginBottom: "10px"}} 
                        onClick={runCode} disabled={isLoading} >
          {isLoading ? "Running..." : "Run Code"}
        </button>
        <div className='mt-2'style={{ height: "40vh", padding: "10px", border: "1px solid #333", borderRadius: "4px", color: isError ? "red" : "black",overflow:"auto" }}>
          {output ? output.map((line, i) => <p key={i}>{line}</p>) : 'Click "Run Code" to see the output here'}
        </div>
      </div>
    );
  };

const MonacoCodeEditor = () => {
  
  const [recordedVideoUrl, setRecordedVideoUrl] = useState(null);
  const [showQuestions, setShowQuestions] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [recordingStopped, setRecordingStopped] = useState(false);
  const [startTime, setStartTime] = useState(null); 
  const [timerId, setTimerId] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState(); 
  const [data, setData] = useState({});
  const [questionsData, setQuestionsData] = useState({});
  const [jobRoleId, setJobRoleId] = useState();
  const [showScreen, setShowScreen] = useState(false);
  const [showInstructions, setShowInstructions] = useState(true); 
  const search = useLocation().search;
  const [jobRoles, setJobRoles] = useState([]);
  const [isActive, setisActive] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [showThankYouMessage, setShowThankYouMessage] = useState(false); 
  const [isRecordingInProgress, setIsRecordingInProgress] = useState(false); 
  const [showWaitMessage, setShowWaitMessage] = useState(false);
  const [endDateMessage, setEndDateMessage] = useState(false);
  const [startDateMessage, setStartDateMessage] = useState(false);
  const [visibilityChangeCount, setVisibilityChangeCount] = useState(0);
  const GuiId = new URLSearchParams(search).get("GuiId");
  const [cameraStarted, setCameraStarted] = useState(false);
  const [MAX_RECORDING_TIME, setMaxRecordingTime] = useState(null);
 const editorRef = useRef();
  const [value, setValue] = useState("");
  const [language, setLanguage] = useState("javascript");
  const [recording, setRecording] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [submitAiQuestions, setSubmitAiQuestions] = useState(false);
  const questionsRef = useRef([]);
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const mediaRecorderRef = useRef(null);
  const recordedChunksRef = useRef([]);
  const screenStreamRef = useRef(null);
  const webcamStreamRef = useRef(null);
  const webcamVideoRef = useRef(null);
  const [resetOutput, setResetOutput] = useState(false);

  const onMount = (editor) => {
    editorRef.current = editor;
    editor.focus();
  };
  const [isOpen, setIsOpen] = useState(true);  // Initially open the first accordion item
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  const onSelect = (language) => {
    setLanguage(language);
    setValue(CODE_SNIPPETS[language] || "");
  };

  const handleNext = () => {
    if (currentQuestionIndex < questionsData.length - 1) {
      setCurrentQuestionIndex((prev) => prev + 1);
        setValue(CODE_SNIPPETS[language] || "");
    
    // Optionally, reset Monaco editor content directly
    if (editorRef.current) {
      editorRef.current.setValue(CODE_SNIPPETS[language] || "");
    }
      // Trigger output reset
    setResetOutput(true);
    setTimeout(() => setResetOutput(false), 0); // toggle back immediately
    }
  };

  const FetchJobroles = () => {
    const GetapiUrl = `${GetInterviewDetailWithOutQuns.APIURL}/${GuiId}`;
    const fetchJSON = async () => {
      const response = await fetch(GetapiUrl);
      let json = await response.json();
      setJobRoles(json);
    };
    fetchJSON();
  };

  const validateGuiId = async () => {
    try {
      const GetapiUrl = `${GetInterviewDetailWithOutQuns.APIURL}/${GuiId}`;
      const response = await Axios.get(GetapiUrl);
      setData(response.data[0]);
      setisActive(response.data[0].isActive);
      const jobRoleid = response.data[0].jobRoleID
      localStorage.setItem('jwtToken', response.data[0].jwtToken)
      setJobRoleId(jobRoleId);
      const startDate = (response.data[0].startDate);
      const endDate = (response.data[0].endDate);
      setMaxRecordingTime(response.data[0].time * 60 * 1000)
      setTimeRemaining(response.data[0].time * 60 * 1000)
      const currentDate = new Date();
      const parsedStartDate = new Date(startDate);
      parsedStartDate.setHours(0, 0, 0, 0); // Set to beginning of day
      const parsedEndDate = new Date(endDate);
      parsedEndDate.setHours(23, 59, 59, 999); // Set to end of day

      if (currentDate < parsedStartDate) {
        console.log("Before start date");
        setStartDateMessage(true);
        setShowScreen(false);
      } else if (currentDate > parsedEndDate) {
        setEndDateMessage(true);
        setShowScreen(false);
      } else {
        setShowScreen(true);
      }

    } catch (error) {
      console.error("Error: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during validation",
        showConfirmButton: false,
        timer: 5000,
      });
    } finally {
      setIsLoading(false); 
    }
  };

  const getJobRoleId = (rolename) => {
    const jobRole = jobRoles.find((role) => role.jobRole == rolename);
    return jobRole ? jobRole.jobRoleId : "";
  };

  useEffect(() => {
    validateGuiId();
    FetchJobroles();
  }, []);
  const fetchQuestions = async () => { 
    const token = localStorage.getItem('jwtToken');
    setSubmitAiQuestions(false);
    try {
      const plainTextJD = data.jobDescription.replace(/<\/?[^>]+(>|$)/g, ""); // Remove HTML tags
      const response = await Axios.post(GenerateContent.APIURL, {
        
           prompt: `Generate exactly ${data.questionsCount} unique coding challenge questions for a programming interview, strictly based on this Job Description: ${plainTextJD}.
 
Rules:
1. Each task must be solvable in 1–2 minutes with a few lines of code.
2. No theory or explanations — only coding tasks.
3. Use very small, clear problems (e.g., reverse a string, sum an array, find max of two numbers).
4. Avoid complex algorithms, nested loops, or tricky edge cases.
5. Keep wording short and direct — no extra context.
6. Output only the questions, numbered 1 to ${data.questionsCount}, one per line.
7. No answers, hints, or sample code.`
      },
      { headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'Authorization': `Bearer ${token}` // Add the Authorization header       
         }}

    );
  
      const textResponse = response.data?.response?.candidates[0].content.parts[0].text;
  
      // Extract only the numbered questions (1-5)
      const questionsArray = textResponse
        .split("\n")
        .map(q => q.trim()) // Remove extra spaces
        .filter(q => /^\d+\./.test(q)) // Keep only lines that start with "1.", "2.", etc.
        .map(q => q.replace(/^\d+\.\s*/, "")); // Remove the numbering (if needed)
  
       // Ensure only 5 questions
      questionsRef.current = questionsArray;    
      setQuestionsData(questionsArray);
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  const handleVisibilityChange = () => {
    if (!recordingStopped && !showThankYouMessage) {
      setVisibilityChangeCount(prevCount => prevCount + 1);
      if (visibilityChangeCount === 1) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recording will be stopped when you change tab/window. Please do not switch tabs.",
          showConfirmButton: false,
          timer: 5000,
        });
      } else if (visibilityChangeCount === 2) {
        stopRecordingWithDelay();
      }
    }
  };
  
  const stopRecordingWithDelay = () => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "You switched tabs again. Recording is now stopping and submitting video.",
      showConfirmButton: false,
      timer: 5000,
    }).then(() => {
      setShowWaitMessage(true);
      setTimeout(() => {
        stopRecording(false);
      }, 3000); // 3 seconds delay
    });
  };
  

  useEffect(() => {
    if (isRecordingInProgress && !recordingStopped) {
      document.addEventListener("visibilitychange", handleVisibilityChange);
    } else {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    }

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isRecordingInProgress, recordingStopped,visibilityChangeCount]);

  useEffect(() => {
    if (startTime && !recordingStopped) {
      const interval = setInterval(() => {
        const elapsedTime = Date.now() - startTime;
        setTimeRemaining(MAX_RECORDING_TIME - elapsedTime);
        if (elapsedTime >= MAX_RECORDING_TIME) {
          stopRecording(true);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [startTime, recordingStopped]);

  const handleCameraOn =async () => {
    setCameraStarted(true);
    try {
      const GetapiUrl = `${HRinitialScreening.APIURL}/${GuiId}`;
      const response = await Axios.get(GetapiUrl);
      if(response.data[0].isCustomQuestionsRequired){
      //  setQuestions(response.data[0].questions)
        const questionsData = response.data[0].questions?.map((x)=>x.questionName)
        setQuestionsData(questionsData);
        console.log(questionsData)
        questionsRef.current = response.data[0].questions;   
        setSubmitAiQuestions(true);
       } 
       
       else{
        await fetchQuestions();
       }
    } catch (error) {
      console.error("Error: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during validation",
        showConfirmButton: false,
        timer: 5000,
      });
    } finally {
      setIsLoading(false); 
    }

    setShowQuestions(true);
    setIsRecordingInProgress(true);
  };

  const startRecording =async () => {

    const id = setTimeout(() => {
      stopRecording(true);
    }, MAX_RECORDING_TIME);
    setTimerId(id);
  
  };

  const startTest = async () => { 
    if (!isChecked) {
        Swal.fire({
        position: "center",
        icon: "warning",
        title: "Please accept the terms and conditions to start the test!",
        showConfirmButton: false,
        timer: 4000,
      });
      return;
    }
  
    try {
      let isVideoRequired = data.isVideoRequired;
  
      // Get screen recording stream (with system audio)
      const screenStream = await navigator.mediaDevices.getDisplayMedia({
        video: {
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          frameRate: { ideal: 30 },
        },
        audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true }   
      });

      // Validate full-screen selection
      const videoTrack = screenStream.getVideoTracks()[0];
      const settings = videoTrack.getSettings();
      if (settings.displaySurface && settings.displaySurface !== "monitor") {
        alert("Please select the entire screen, not a window or tab.");
        screenStream.getTracks().forEach((track) => track.stop());
        return;
      }

      await handleCameraOn();
      setShowVideo(true);
      let webcamStream = null;

      // Get microphone audio (always)
      const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const micAudioTrack = audioStream.getAudioTracks()[0];
  

  
      // If isVideoRecording is true, get webcam and microphone stream
      if (isVideoRequired) {
        webcamStream = await navigator.mediaDevices.getUserMedia({
          video: { width: 320, height: 240 },
          audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
        });
  
        // Display webcam preview
        webcamVideoRef.current.srcObject = webcamStream;
        webcamVideoRef.current.play();
      }
  
      // Store screen stream
      screenStreamRef.current = screenStream;
      if (isVideoRequired) {
        webcamStreamRef.current = webcamStream;
      }
  
      // Extract screen audio
      const screenAudioTrack = screenStream.getAudioTracks().find(track => track.kind === "audio");
  if (screenAudioTrack && micAudioTrack) {
  await Swal.fire({
    position: "center",
    title: "Please Do not turn on the system audio",
    showConfirmButton: false,
    timer: 5000,
   imageUrl: alertimg,
  imageWidth: 200,
  imageHeight: 200,
  imageAlt: "Audio warning",
  });
  window.location.reload();
  return;
}
      // Combine video and audio streams
      const combinedStream = new MediaStream([
        ...screenStream.getVideoTracks(), // Always record screen video
        ...(isVideoRequired && webcamStream ? webcamStream.getVideoTracks() : []), // Webcam video if enabled
        ...(screenAudioTrack ? [screenAudioTrack] : []), // System audio (if available)
        ...(micAudioTrack ? [micAudioTrack] : []), // Microphone audio (if available)
      ]);
  
      // Start recording
      recordedChunksRef.current = [];
      mediaRecorderRef.current = new MediaRecorder(combinedStream, {
        mimeType: "video/webm",
      });

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) recordedChunksRef.current.push(event.data);
      };

      mediaRecorderRef.current.start();
      startRecording();
      setStartTime(Date.now());
      setRecording(true);
      setShowInstructions(false);
      setShowQuestions(true);
      setIsExpanded(true);
      // Stop recording when screen sharing ends
      screenStream.getVideoTracks()[0].onended = stopRecording;
    } catch (error) {
      alert("Screen recording failed. Please allow full-screen recording.");
    }
};
  const stopRecording = async() => {
    mediaRecorderRef.current?.stop();
    screenStreamRef.current?.getTracks().forEach((track) => track.stop());
    webcamStreamRef.current?.getTracks().forEach((track) => track.stop());
     mediaRecorderRef.current.onstop = async() => {
        const blob = new Blob(recordedChunksRef.current, { type: "video/webm" });
        console.log("blob",blob)
        setVideoUrl(URL.createObjectURL(blob));
        setRecordedVideoUrl(blob); // Save the actual blob
        await handleRecordingComplete(blob)
      };
    setRecording(false);
    setRecordingStopped(true);
    setIsRecordingInProgress(false);
   
  };
  
  const handleRecordingComplete = async (videoBlob) => {
    console.log("videoBlob",videoBlob)
    // const videoUrl = URL.createObjectURL(videoBlob);
    //setRecordedVideoUrl(videoBlob);
    setShowWaitMessage(true);
    setIsLoading(false);

    setRecordingStopped(true);
    setIsRecordingInProgress(false);
    clearTimeout(timerId);
    setTimeout(async () => {
      setShowWaitMessage(false); 
      setIsLoading(true); 

      try {
        const formData = new FormData();
        formData.append("guid", GuiId);
        formData.append("CandidateName", data?.name);
        formData.append("videoUrl", URL.createObjectURL(videoBlob));
        formData.append("video", videoBlob, "recording.webm");
        console.log("formData",formData)
        const response = await Axios.post(
          TestSaveCandidateRecordedVideo.APIURL,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setIsLoading(false);

        // if (response.status === 200) {
          if (response.data == 'Video uploaded successfully') {

            if(submitAiQuestions == true){
              await submitQuestions();
            }
            else{
          await  AddAIQuestions(); 
            }
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Video uploaded successfully",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            setShowThankYouMessage(true); // Show thank you message after success alert
          });
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Failed to upload video",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.error("Error uploading video: " + error);
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "An error occurred during video upload",
          showConfirmButton: false,
          timer: 5000,
        });
        setIsLoading(false);
      }
    }, 4000); // Delay of 5 seconds
  };

  const submitQuestions = async () => {
    try {
      const params = {
        guid: GuiId,
        questions: questionsRef.current,
        jobRoleId: data?.jobRoleID,
      };

      await Axios.post(PostAttemptedQuestions.APIURL, params);
    } catch (error) {
      console.error("Error submitting questions: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during questions submission",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
  const AddAIQuestions = async () => {
    try {
      const params = {
        guiID: GuiId,
        codingIntQuns: JSON.stringify(questionsRef.current),
        "testTypeID": 2,
      };

      await Axios.post(AddCodingIntQuns.APIURL, params);
    } catch (error) {
      console.error("Error submitting questions: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during questions submission",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
   const handleSubmission = () => {
    stopRecording();
    setRecordingStopped(true);
    setIsRecordingInProgress(false);
    console.log("reurl",recordedVideoUrl)
    handleRecordingComplete(recordedVideoUrl); 
  };
  
  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  if (isLoading) {
    return (
      <center>
        <LoadingSpinner />
      </center>

    );
  }

  if (showWaitMessage) {
    return (

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <h3>Please don't close the window until you are notified that your video has been successfully saved. </h3>
        </div>
      </div>

    )
  }

  if (startDateMessage) {
    return (

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <h3>Please wait untill Interview.Reach out to <b style={{ color: "#00a7ac" }}>hire@knackhook.com</b> if you have any questions.</h3>
        </div>
      </div>

    )
  }
  if (endDateMessage) {
    return (

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <h3>Link has Expired.Please reach out to <b style={{ color: "#00a7ac" }}>hire@knackhook.com</b> if you have any questions.</h3>
        </div>
      </div>

    )
  }

  return (
    <NoMobileAccess>
      {showScreen && isActive ? (
        <div style={{ flexDirection: "row" }}>
          {recordingStopped ? (
            showThankYouMessage ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <div className="container" style={{ textAlign: "center" }}>
                  <h4>Thank you for attending the interview, please reach out to <b style={{ color: "#00a7ac" }}>hire@knackhook.com</b> if you have any questions. Now you can close the browser window.</h4>
                </div>
              </div>
            ) : (
              <></>
            )
          ) : (
            <div className="container mt-2 pb-5">
            
             
              <div className="card shadow-lg p-4" style={{ border: "none" }}>
                {/* {showQuestions && (
                  <div className="mb-3">
                    <button
                      onClick={stopRecording}
                      disabled={!cameraStarted}
                      className="btn btn-primary mt-3"
                      style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: 15, float: "right" }}
                    >
                      Submit
                    </button>
                  </div>
                )} */}
                <div>
                <div className="row">
                <div className={`col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isExpanded ? 'd-none' : ''}`}>
                    {/* User Information Card */}
           <div className="card shadow-lg p-3 text-center" style={{border: 'none', backgroundColor: '#00a7ac', color: '#fff'}}>
             <p className="text-para" style={{fontSize: 15}}>Name: <b>{data.name}</b></p>
             <p className="text-para" style={{fontSize: 15}}>Email: <b>{data.email}</b></p>
             <p className="text-para" style={{fontSize: 15}}>Time : <b>{formatTime(timeRemaining)}</b></p>
           </div>
 
           {/* Accordion for Instructions */}
           <div className="accordion mt-3 shadow-lg" id="accordionExample">
             <div className="accordion-item">
               <h2 className="accordion-header" id="headingThree">
                 <button
                   className="accordion-button"
                   type="button"
                   onClick={toggleAccordion} // Toggles the collapse on button click
                   aria-expanded={isOpen ? "true" : "false"} // Dynamically update the expanded state
                   aria-controls="collapseThree"
                   style={{ fontWeight: 'bold', paddingRight: '30px', backgroundColor: '#fff', color: '#00a7ac' }}
                 >
                   Online Assessment Instructions and Consent
                 </button>
               </h2>
               <div
                 id="collapseThree"
                 className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`} // Add 'show' class when open
                 aria-labelledby="headingThree"
                 data-bs-parent="#accordionExample"
               >
                 <div className="accordion-body" style={{height: '400px', overflowY: 'auto'}}>
                   {/* Instructions Content */}
                   <h5 style={{fontSize: 15 }}><b>1. Webcam & Consent:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Keep your webcam ON during the test for integrity.
                     </li>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 18, color: "#00a7ac", marginRight: 10 }}></i>
                       Your video (image & audio) will be recorded for assessment purposes.
                     </li>
                   </ul>
 
                   <h5 style={{fontSize: 15 }}><b>2. Data Privacy</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Videos are securely stored and will be deleted once the job post is closed.
                     </li>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Used only for evaluating your test performance at KnackHire.
                     </li>
                   </ul>
 
                   <h5 style={{ fontSize: 15 }}><b>3. Submission Rules:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{ fontSize: 15 }}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       One attempt only – ensure all answers are completed before submitting.
                     </li>
                     {/* <li className="text-para" style={{ fontSize: 15 }}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       On clicking the <b>Start Answering</b> button, your answer will be recorded, and your score will be based on that recorded answer only.
                     </li> */}
                     <li className="text-para" style={{ fontSize: 15 }}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       If you want the AI to read the question aloud, click on the <b>Read Question</b> button.
                     </li>
                     <li className="text-para" style={{ fontSize: 15 }}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       To move to the next question, click on the <b>Next Question</b> button.
                     </li>
                     <li className="text-para" style={{ fontSize: 15 }}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Click "Submit" to successfully complete the test.
                     </li>
                   </ul>
 
                   <h5 style={{fontSize: 15 }}><b>4. Malpractice Policy:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Any malpractice (tab switching, googling, copy-pasting) will lead to automatic submission.
                     </li>
                   </ul>
 
                   <h5 style={{fontSize: 15 }}><b>5. Test Timing:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Timer starts once you begin. Test auto-submits when time ends.
                     </li>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Do not close the window until you see confirmation of video submission.
                     </li>
                   </ul>
 
                   <h5 style={{fontSize: 15 }}><b>6. Device Usage:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       Use only your device’s built-in webcam, microphone & keyboard. No external devices.
                     </li>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       No earphones/earbuds allowed.
                     </li>
                   </ul>
 
                   <h5 style={{fontSize: 15 }}><b>7. Introduction Requirement:</b></h5>
                   <ul style={{ listStyle: 'none', padding: 0 }}>
                     <li className="text-para" style={{fontSize: 15}}>
                       <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                       <b> Before starting, introduce yourself (Name, Experience, Core Skills, Recent Projects).<br />📌 Follow these guidelines to ensure a smooth assessment process. Good luck! 🚀</b>
                     </li>
                   </ul>
 
                   {/* Consent Checkbox */}
                   <div className="form-check mt-3 ml-3">
  <input 
    className="form-check-input" 
    type="checkbox" 
    id="consentCheckbox" 
    checked={isChecked} 
    onChange={handleCheckboxChange} 
  />
  <label className="form-check-label" htmlFor="consentCheckbox" style={{ fontSize: 15, color: "red" }}>
  I have read and understood the instructions.
  </label>
</div>

                 </div>
               </div>
             </div>
           </div>
           {!showQuestions &&
      <button
        onClick={startTest}
        className="btn btn-primary mt-3 mb-3"
        style={{
          backgroundColor: "#00a7ac",
          border: "none",
          borderRadius: 15,
        }}
      >
        Start Test
      </button>
    }
</div>

<div className={`col-sm-12 col-lg-${isExpanded ? 12 : 6} col-xl-${isExpanded ? 12 : 6} col-md-${isExpanded ? 12 : 6}`}>

<div className="row">
<div className="col-sm-12 col-lg-8 col-xl-8 col-md-8">
  {showQuestions && (
                        <div >
                          
                          {/* <p className="text-para">
                            <b> Please provide a brief introduction about yourself, including your Name, Experience, core technical skills, and recent project details.</b>
                          </p> */}
                        
                      
                          {questionsData && questionsData.length > 0 && (
        <>
          <div>
            <strong style={{ color: "#00a7ac" }}>
              Question {currentQuestionIndex + 1} of {questionsData.length}:
            </strong>
          </div>

          <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
            <li>
              <div className="commenttt-wrapper">
                <span style={{ fontSize: 18 }} className="text-paraa mr-2">
                  {currentQuestionIndex + 1}.
                </span>
                <span className="text-paraa" style={{ fontSize: 18 }}>
                  {parse(DOMPurify.sanitize(questionsData[currentQuestionIndex]))}
                </span>
              </div>
             
            </li>
          </ul>

        
        </>
      )}

                        </div>
                      )}

</div>
 <div class="col-sm-12 col-lg-4 col-xl-4 col-md-12">
  <div className="d-flex">
 
  <div >
     {showQuestions && (
    <div style={{ border: 'none' }}>
      <div style={{ margin: 'auto' }}>
        {/* Show "Next Question" only if NOT on the last question */}
        {currentQuestionIndex < questionsData.length - 1 && (
          <button
            onClick={handleNext}
            className="btn btn-primary"
            style={{
              backgroundColor: "#00a7ac",
              border: "none",
              borderRadius: 15,
              width: '140px',
              marginRight:11

            }}
          >
       <i className="fa fa-arrow-right" aria-hidden="true" style={{ color: "#fff", backgroundColor: "#00a7ac" }}></i>  Next Question
          </button>
        )}

        {/* Show "Submit" only on the last question */}
        {currentQuestionIndex === questionsData.length - 1 && (
          <button
            onClick={stopRecording}
            disabled={!cameraStarted}
            className="btn btn-success"
            style={{
              backgroundColor: "green",
              border: "none",
              borderRadius: 15,
              width: '140px',
              marginRight:11
            }}
          >
            Submit
          </button>
        )}
      </div>
    </div>
  )}
  </div>
   <div>
    <button 
     className="btn btn-primary mb-3"
    style={{
      backgroundColor: "#00a7ac",
      border: "none",
      borderRadius: 15,
      width: '140px',
    }}>
      Time : <b>{formatTime(timeRemaining)}</b>
    </button>
  </div>
{/* {showQuestions &&  <div>
    <p 
      className="text-para" 
      style={{ 
        fontSize: 30,
        color: '#00a7ac',
        
      }}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <i className="fa fa-expand"></i> 
    </p>
  </div>
} */}
</div>
  </div>
    </div>
<div
  className=""
  style={{
    border: 'none',
    height: '120px',
    width: '300px',
    margin: 'auto'
  }}
>
  <div className="row">
    {showVideo && (
      <div className="" style={{ border: 'none' }}>
        {data.isVideoRequired ? (
          <>
            <video
              ref={webcamVideoRef}
              autoPlay
              muted
              className="w-100"
              style={{ height: '150px', objectFit: 'cover' }} // 70% of 500px
            />
            {videoUrl && (
              <video
                src={videoUrl}
                controls
                className="w-100"
                style={{ height: '105px', objectFit: 'cover' }} // 70% of 150px
              />
            )}
          </>
        ) : (
          <img
            src={ailogo}
            alt="AI Logo"
            className="w-100"
            style={{ height: '150px', objectFit: 'cover' }} // 70% of 500px
          />
        )}
      </div>
    )}
 
    <div className="col-sm-12 col-lg-2 col-xl-2 col-md-2"></div>
  </div>
</div>
    {showQuestions &&  <div className="row mt-2">
                    <div className="col-sm-12 col-xl-6 col-lg-6 col-md-6 mt-5">
            <h6 style={{color:"#00a7ac"}}>Select Language</h6>
          <select className='col-12 form-control basic-form' onChange={(e) => onSelect(e.target.value)} style={{marginBottom:20}}>
          <option value=""> ---Select Language---</option>
            {Object.keys(CODE_SNIPPETS).map((lang) => (
              <>
              <option key={lang} value={lang}>{lang.toUpperCase()}</option></>
            ))}
          </select>
          <Editor 
            options={{ minimap: { enabled: false } }}
            height="40vh"
            theme="vs-dark"
            language={language}
            defaultValue={CODE_SNIPPETS[language] || ""}
            onMount={onMount}
            value={value}
            onChange={(value) => setValue(value)}
          />
        </div>
        <div className="col-sm-12 col-xl-6 col-lg-6 col-md-6 mt-5">

<Output editorRef={editorRef} language={language}  resetTrigger={resetOutput} />
<div className="text-center">

</div>
</div>
        </div>
}




  </div>


 
                               </div>
                 
                          
                 
              
                            

                                 <div className="col-sm-12 col-lg-6 col-xl-6">

                {/* <ScreenRecorder /> */}
                                              </div>
                          
              
                      
     
      </div>
   
     
    </div>
                  
                </div>
             
          )}
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <div className="container" style={{ textAlign: "center" }}>
            <h4>You have already attempted the interview, please reach out to <b style={{ color: "#00a7ac" }}>hire@knackhook.com</b> if you have any questions.</h4>
          </div>
        </div>
      )}
     
      </NoMobileAccess>
      );
};

export default MonacoCodeEditor;